module.exports = __webpack_public_path__ + "img/map2.384fc0d6.jpg";